function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_304",
  "data-name": "Group 304",
  transform: "translate(-833.055 -2395.586)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Arrow_right",
  "data-name": "Arrow right",
  transform: "translate(834.055 2397)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line",
  d: "M0,1H18.945",
  transform: "translate(0 6.578)",
  fill: "none",
  stroke: "#03124a",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Head",
  d: "M0,0,7.578,7.578,0,15.156",
  transform: "translate(11.367)",
  fill: "none",
  stroke: "#03124a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Arrow_right-2",
  "data-name": "Arrow right",
  transform: "translate(853 2427.156) rotate(180)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Line-2",
  "data-name": "Line",
  d: "M0,1H18.945",
  transform: "translate(0 6.578)",
  fill: "none",
  stroke: "#03124a",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Head-2",
  "data-name": "Head",
  d: "M0,0,7.578,7.578,0,15.156",
  transform: "translate(11.367)",
  fill: "none",
  stroke: "#03124a",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
})));

var SvgDoubleArrows = function SvgDoubleArrows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.945,
    height: 32.985,
    viewBox: "0 0 20.945 32.985",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoubleArrows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DoubleArrows.dd71e507.svg";
export { ForwardRef as ReactComponent };